import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useMouse, useWindowSize } from 'react-use';
import styled from 'styled-components';
import { themeColorValues } from '../../../theme';
import { prepareData } from '../data';
import { shortDateFormatter, shortNumericFormatter, } from '../formatters';
import { GraphKeys } from '../GraphKeys';
import { GraphTooltip } from '../GraphTooltip';
export function prepareDynamicDataSetProps(dataSets) {
    return dataSets.reduce((acc, dataSet, i) => {
        acc[dataSet.id] = {
            label: dataSet.id,
            color: themeColorValues[i],
        };
        return acc;
    }, {});
}
const Svg = styled.svg `
  flex: 1;
  width: 100%;
  height: 100%;

  .xAxis,
  .yAxis {
    font: 12px Helvetica;

    path {
      opacity: 0;
    }

    line {
      color: rgba(0, 0, 0, 0.05);
      shape-rendering: crispEdges;
    }
  }

  .ruler {
    color: rgba(0, 0, 0, 0.3);
    stroke-width: 1;
    stroke: currentColor;
  }
`;
const Container = styled.div `
  display: flex;
  flex-direction: column;
  min-height: 250px;
  min-width: 200px;
  color: #666;
  position: relative;
`;
export const Graph = (props) => {
    const svgRef = useRef(null);
    const [hoverRows, setHoverRows] = useState();
    const [coords, setCoords] = useState();
    const windowSize = useWindowSize();
    const mouse = useMouse(svgRef);
    const dataSetProps = useMemo(() => props.dataSetProps
        ? props.dataSetProps
        : prepareDynamicDataSetProps(props.chartData.dataSets), [props.chartData.dataSets, props.dataSetProps]);
    const graphData = useMemo(() => prepareData(props.chartData, dataSetProps || {}), [props.chartData, dataSetProps]);
    useEffect(() => {
        if (!svgRef.current) {
            return;
        }
        props.renderer(svgRef.current, graphData, {
            onHover: setHoverRows,
            xTickFormatter: props.xLabelFormatter ?? shortDateFormatter,
            yTickFormatter: props.yLabelFormatter ?? shortNumericFormatter,
        });
    }, [props, svgRef, graphData, windowSize]);
    /** Track tooltip position */
    useEffect(() => {
        if (!svgRef.current) {
            return;
        }
        const outside = mouse.elX < 0 ||
            mouse.elX > mouse.elW ||
            mouse.elY < 0 ||
            mouse.elY > mouse.elH;
        setCoords((!outside && [mouse.elX + 10, mouse.elY]) || undefined);
    }, [mouse]);
    return (React.createElement(Container, null,
        React.createElement(Svg, { ref: svgRef, "data-testid": "Graph__svg" }),
        React.createElement(GraphKeys, { graphData: graphData }),
        hoverRows && coords && (React.createElement(GraphTooltip, { rows: hoverRows, coords: coords, valueFormatter: props.valueFormatter }))));
};
